<template>
	<v-list-item style="border-radius: 5px; border: 1px solid #e3e3e3">
		<v-list-item-content>
			<v-list-item-title class="primary--text">
				{{monitoredSymptom.description}}
				<div style="float: right" class="text-caption">
					<v-icon class="mr-1" small color="primary">mdi-account-tie</v-icon>
					<span class="mr-2">{{monitoredSymptom.user_name}}</span>
					<v-icon class="mr-1" small color="primary">mdi-account</v-icon>
					<span>{{monitoredSymptom.patient_name}}</span>
				</div>
			</v-list-item-title>
			<v-list-item-subtitle>
				<v-chip
					small
					class="mt-2"
					color="#f2f2f2"
				>{{monitoredSymptom.symptom.code}} - {{monitoredSymptom.symptom.title}}</v-chip>
				<template v-if="monitoredSymptom.active_extensions.length > 0">
					<v-chip
						small
						class="mt-2 ml-1"
						color="#f2f2f2"
						v-for="extension in monitoredSymptom.active_extensions"
						:key="extension.id"
					>{{extension.code}} - {{extension.title}}</v-chip>
				</template>
			</v-list-item-subtitle>
			<v-row no-gutters>
				<v-col v-if="monitoredSymptom.info" cols="12" class="mt-1 text-body-2 font-weight-thin" style="white-space: pre-line;">{{monitoredSymptom.info}}</v-col>
				<v-col cols="12" class="mt-3">
					<v-row no-gutters>
						<v-btn
							:disabled="!hasPermission"
							text
							small
							color="primary"
							@click="showRecords = !showRecords"
						>
							<translate>Progress</translate>
							<v-icon v-if="!showRecords" color="primary">mdi-chevron-down</v-icon>
							<v-icon v-else color="primary">mdi-chevron-up</v-icon>
						</v-btn>
						<span v-if="!hasPermission" class="text-caption mt-1 mr-1 red--text">
							<v-icon class="mr-1" small color="red">mdi-account-cancel</v-icon>
							<translate key="not-shared">Not Shared</translate>
						</span>
						<span v-if="sharedUser" class="text-caption mt-1 mr-1 green--text">
							<v-icon class="mr-1" small color="green">mdi-account-multiple</v-icon>
							<translate key="shared">Shared</translate>
						</span>
						<span v-if="beingShared" class="text-caption mt-1 mr-1 green--text">
							<v-icon class="mr-1" small color="green">mdi-account-multiple</v-icon>
							<translate key="shared">Sharing</translate>
						</span>
						<span v-if="!monitoredSymptom.active" class="text-caption mt-1 red--text">
							<v-icon class="mr-1" small color="red">mdi-cancel</v-icon>
							<translate key="shared">Deactivated</translate>
						</span>
						<v-spacer></v-spacer>
						<template v-if="showOptions">
							<v-btn text small color="primary" @click="showShareMonitoring = true">
								<translate key="share">Share</translate>
								<v-icon small class="ml-1" color="primary">mdi-account-multiple-check</v-icon>
							</v-btn>
							<v-dialog v-model="showShareMonitoring" width="30%" scrollable>
								<v-card>
									<v-card-title class="title primary--text mb-2 secondary">
										<v-icon class="mr-3" color="primary">mdi-account-multiple-check</v-icon>
										<translate>Share Monitoring</translate>
									</v-card-title>
									<v-card-text>
										<p
											v-if="sharedProfessionals.length == 0"
											class="grey--text my-3"
											v-translate
										>No Professionals selected.</p>
										<v-list v-else flat>
											<v-list-item-group>
												<v-list-item
													v-for="professional in sharedProfessionals"
													:key="professional.id"
													style="border: 1px solid #e0e0e0; border-radius: 5px"
													@click="selectProfessional(professional)"
												>
													<v-list-item-icon class="mr-3">
														<v-icon color="primary">mdi-account</v-icon>
													</v-list-item-icon>
													<v-list-item-content>
														<v-list-item-title>
															<strong>{{professional.name}}</strong>
														</v-list-item-title>
													</v-list-item-content>
													<v-list-item-action>
														<v-row no-gutters align="center">
															<v-checkbox
																@click="selectProfessional(professional)"
																v-model="professional.selected"
																color="primary"
															></v-checkbox>
														</v-row>
													</v-list-item-action>
												</v-list-item>
											</v-list-item-group>
										</v-list>
										<v-divider></v-divider>
										<p
											v-if="otherProfessionals.length == 0"
											class="grey--text my-3"
											v-translate
										>No Professionals available.</p>
										<v-list v-else flat>
											<v-list-item-group>
												<v-list-item
													v-for="professional in otherProfessionals"
													:key="professional.id"
													style="border: 1px solid #e0e0e0; border-radius: 5px"
													@click="selectProfessional(professional)"
												>
													<v-list-item-icon class="mr-3">
														<v-icon color="primary">mdi-account</v-icon>
													</v-list-item-icon>
													<v-list-item-content>
														<v-list-item-title>
															<strong>{{professional.name}}</strong>
														</v-list-item-title>
													</v-list-item-content>
													<v-list-item-action>
														<v-row no-gutters align="center">
															<v-checkbox
																@click="selectProfessional(professional)"
																v-model="professional.selected"
																color="primary"
															></v-checkbox>
														</v-row>
													</v-list-item-action>
												</v-list-item>
											</v-list-item-group>
										</v-list>
									</v-card-text>
									<v-divider></v-divider>
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn
											:disabled="!sharedProfessionalsChanged"
											color="primary darken-1"
											text
											@click="saveSharedProfessionals"
										>
											<translate>Save</translate>
										</v-btn>
										<v-btn color="primary darken-1" text @click="showShareMonitoring = false">
											<translate>Close</translate>
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-dialog>
							<v-btn text small color="primary" @click="changeStatus">
								<template v-if="monitoredSymptom.active">
									<translate key="deactivate">Deactivate</translate>
									<v-icon small class="ml-1" color="primary">mdi-power</v-icon>
								</template>
								<template v-else>
									<translate key="activate">Activate</translate>
									<v-icon small class="ml-1" color="primary">mdi-power</v-icon>
								</template>
							</v-btn>
							<v-btn text small color="primary" @click="showDeleteMonitoring = true">
								<translate key="delete">Delete</translate>
								<v-icon small class="ml-1" color="primary">mdi-delete-circle</v-icon>
							</v-btn>
							<v-dialog v-model="showDeleteMonitoring" width="30%" scrollable>
								<v-card>
									<v-card-title class="title primary--text mb-2 secondary">
										<v-icon class="mr-3" color="primary">mdi-delete-circle</v-icon>
										<translate>Delete Monitoring</translate>
									</v-card-title>
									<v-card-text>
										<p
											class="grey--text my-3"
											v-translate
										>Are you sure you want to delete this monitored symptom? All records will be gone forever.</p>
									</v-card-text>
									<v-divider></v-divider>
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn color="primary darken-1" text @click="deleteMonitoring" :loading="loading">
											<translate>Yes</translate>
										</v-btn>
										<v-btn color="primary darken-1" text @click="showDeleteMonitoring = false">
											<translate>No</translate>
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-dialog>
						</template>
						<v-btn
							:disabled="$store.getters.userId != monitoredSymptom.user_id || !$store.getters.hasAnyModule"
							v-if="userType != 'patient'"
							class="ml-2"
							icon
							small
							color="primary"
							@click="showOptions = !showOptions"
						>
							<v-icon v-if="!showOptions" color="primary">mdi-cog</v-icon>
							<v-icon v-else color="primary">mdi-cog-outline</v-icon>
						</v-btn>
						<template v-else>
							<v-btn
								class="ml-2 primary--text"
								depressed
								small
								color="secondary"
								@click="showAddRecord = true"
							>
								<translate>Add Record</translate>
								<v-icon small color="primary">add</v-icon>
							</v-btn>
							<MonitoredSymptomRecord
								:show="showAddRecord"
								@close="showAddRecord = false"
								@add-record="addRecord"
								ref="addRecord"
							/>
							<MonitoredSymptomRecord
								:show="showEditRecord"
								:edit="true"
								:record="recordToEdit"
								@close="showEditRecord = false"
								@edit-record="editRecord"
								ref="editRecord"
							/>
						</template>
					</v-row>
				</v-col>
				<v-col v-if="showRecords" cols="12">
					<p
						v-if="monitoredSymptom.records.length == 0"
						class="font-weight-thin ml-2 mt-3"
						v-translate
					>No monitoring info.</p>
					<template v-else>
						<v-col cols="12" class="pb-0">
							<v-btn-toggle style="display: block" v-model="dataType">
								<v-btn value="graph" small class="my-1">
									<v-icon small color="primary" class="mr-2">mdi-chart-timeline-variant</v-icon>
									<translate>Graph</translate>
								</v-btn>
								<v-btn value="table" small class="my-1">
									<v-icon color="primary" class="mr-2">mdi-table</v-icon>
									<translate>Table</translate>
								</v-btn>
							</v-btn-toggle>
						</v-col>
						<v-col cols="12">
							<v-card class="mx-auto" elevation="1">
								<template v-if="dataType == 'graph'">
									<!-- <GChart v-if="dataType == 'graph'" type="LineChart" :data="data" :options="chartOptions" /> -->
									<MonitoredSymptomChart
										class="pa-5 pb-0"
										:id="monitoredSymptom.disease_id"
										:records="monitoredSymptom.records"
									/>
								</template>
								<v-simple-table v-else>
									<template v-slot:default>
										<thead>
											<tr>
												<th class="text-left" v-translate>Date</th>
												<th class="text-left" v-translate>Hour</th>
												<th class="text-left" v-translate>Intensity</th>
												<th v-if="userType == 'patient'"></th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="record in monitoredSymptom.records" :key="record.id">
												<td>{{ record.date }}</td>
												<td>{{ record.time }}</td>
												<td>
													<b>{{ record.intensity }}</b>
												</td>
												<td align="right" width="100px" v-if="userType == 'patient'">
													<v-btn small icon @click="openEditRecord(record)">
														<v-icon small color="primary">mdi-pencil-outline</v-icon>
													</v-btn>
													<v-btn small icon @click="deleteRecord(record)">
														<v-icon small color="primary">mdi-delete-outline</v-icon>
													</v-btn>
												</td>
											</tr>
										</tbody>
									</template>
								</v-simple-table>
								<v-card-text class="pt-0">
									<v-divider class="my-2"></v-divider>
									<v-icon class="mr-2" small>mdi-clock</v-icon>
									<span class="text-caption grey--text font-weight-light">
										<translate
											:translate-params="{lastMonitorization: lastMonitorization}"
										>last monitorization %{lastMonitorization} ago</translate>
									</span>
								</v-card-text>
							</v-card>
						</v-col>
					</template>
				</v-col>
			</v-row>
		</v-list-item-content>
	</v-list-item>
</template>

<script>
//import { GChart } from "vue-google-charts";
import axios from "axios";
import MonitoredSymptomRecord from "@/components/patient/MonitoredSymptomRecord.vue";
import MonitoredSymptomChart from "@/components/patient/MonitoredSymptomChart.vue";

export default {
	name: "MonitoredSymptom",
	props: ["monitoredSymptom", "userType", "monitoringTab"],
	components: {
		//GChart,
		MonitoredSymptomRecord,
		MonitoredSymptomChart
	},
	data: () => ({
		showRecords: false,
		showOptions: false,
		showShareMonitoring: false,
		showDeleteMonitoring: false,
		showAddRecord: false,
		showEditRecord: false,
		recordToEdit: {},
		sharedProfessionalsChanged: false,
		dataType: "graph",
		professionals: [],
		loading: false
	}),
	computed: {
		data() {
			const data = [[this.$gettext("Date"), this.$gettext("Intensity")]];
			this.monitoredSymptom.records.forEach(r => {
				let date = new Date(r.date + "T" + r.time);
				data.push([
					date.toLocaleString(this.$store.getters.userLanguage, {
						month: "long",
						day: "numeric",
						hour: "numeric",
						minute: "numeric"
					}),
					r.intensity
				]);
			});
			return data;
		},
		values() {
			const values = [];
			this.monitoredSymptom.records.forEach(r => {
				values.push(r.intensity);
			});
			return values;
		},
		chartOptions() {
			return {
				chart: {
					title: "Monitored Symptom",
					subtitle: "..."
				},
				legend: { position: "none" },
				series: {
					0: { color: this.$vuetify.theme.themes.light.primary.base }
				},
				vAxis: {
					title: this.$gettext("Intensity"),
					gridlines: {
						count: 11,
						interval: [1]
					},
					minorGridlines: {
						count: 0
					},
					viewWindowMode: "pretty",
					ticks: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
				},
				hAxis: {
					baseline: 11,
					baselineColor: "red"
				}
			};
		},
		lastMonitorization() {
			const lastRecord = this.monitoredSymptom.records[
				this.monitoredSymptom.records.length - 1
			];
			const lastDate = new Date(lastRecord.date + "T" + lastRecord.time);
			const today = new Date();
			const difference = today - lastDate;
			const days = Math.round(difference / (1000 * 60 * 60 * 24));
			if (days != 0) return days + " " + this.$gettext("days");
			else {
				const hours = Math.round(difference / (1000 * 60 * 60));
				if (hours != 0) return hours + " " + this.$gettext("hours");
				else {
					const minutes = Math.round(difference / (1000 * 60));
					if (minutes != 0) return minutes + " " + this.$gettext("minutes");
				}
			}
			return days;
		},
		sharedProfessionals() {
			return this.professionals.filter(p => p.selected);
		},
		otherProfessionals() {
			return this.professionals.filter(p => !p.selected);
		},
		hasPermission() {
			if (this.userType == "patient") return true;
			if (!this.notOwn) return true;
			if (this.sharedUser) return true;
			return false;
		},
		notOwn() {
			const userId = this.$store.getters.userId;
			if (this.monitoredSymptom.user_id == userId) return false;
			else return true;
		},
		beingShared() {
			if (this.userType == "patient") return false;
			if (this.monitoredSymptom.shared_users.length > 0 && !this.notOwn)
				return true;
			return false;
		},
		sharedUser() {
			if (this.userType == "patient") return false;
			const userId = this.$store.getters.userId;
			for (const u of this.monitoredSymptom.shared_users) {
				if (u.id == userId) return true;
			}
			return false;
		}
	},
	methods: {
		changeStatus() {
			axios
				.post("/monitored_symptom/" + this.monitoredSymptom.id + "/change_status")
				.then(response => {
					if (response.data.result == "ok")
						this.monitoredSymptom.active = !this.monitoredSymptom.active;
					if (!this.monitoredSymptom.active && this.monitoringTab)
						this.$emit("delete-monitored-symptom", this.monitoredSymptom);
				})
				.catch(error => console.log(error));
		},
		selectProfessional(professional) {
			professional.selected = !professional.selected;
			this.sharedProfessionalsChanged = true;
		},
		saveSharedProfessionals() {
			console.log("SAVING");
			const data = {
				shared_users: []
			};
			this.sharedProfessionals.forEach(p => {
				data.shared_users.push(p);
			});
			axios
				.post("/monitored_symptom/" + this.monitoredSymptom.id + "/shared_users", data)
				.then(response => {
					console.log(response.data);
					this.monitoredSymptom.shared_users = response.data.shared_users;
					this.showShareMonitoring = false;
				})
				.catch(error => console.log(error));
		},
		deleteMonitoring() {
			this.loading = true;
			axios
				.post("/monitored_symptom/" + this.monitoredSymptom.id + "/delete")
				.then(response => {
					console.log(response.data);
					if (response.data.result == "ok") {
						this.$emit("delete-monitored-symptom", this.monitoredSymptom);
					}
					this.showDeleteMonitoring = false;
					this.loading = false;
				})
				.catch(error => {
					console.log(error);
					this.loading = false;
				});
		},
		createForm(record) {
			const formData = new FormData();
			formData.append("intensity", record.intensity - 1);
			formData.append("date", record.date);
			formData.append("time", record.time);
			return formData;
		},
		addRecord(record) {
			const key = this.$route.query.key;
			const formData = this.createForm(record);
			axios
				.post(
					"/patient/" +
						this.monitoredSymptom.patient_id +
						"/monitored_symptoms/" +
						this.monitoredSymptom.id +
						"/new_record?key=" +
						key,
					formData
				)
				.then(response => {
					console.log(response.data);
					if (response.data.result == "ok")
						//this.monitoredSymptom.records.push(response.data.record);
						this.$emit(
							"add-record",
							this.monitoredSymptom,
							response.data.record
						);
					this.showAddRecord = false;
				})
				.catch(error => {
					console.log(error);
					this.$refs.addRecord.setError();
				});
		},
		deleteRecord(record) {
			const key = this.$route.query.key;
			axios
				.post(
					"/patient/" +
						this.monitoredSymptom.patient_id +
						"/record/" +
						record.id +
						"/delete?key=" +
						key
				)
				.then(response => {
					console.log(response.data);
					if (response.data.result == "ok")
						this.$emit("delete-record", this.monitoredSymptom, record);
				})
				.catch(error => console.log(error));
		},
		editRecord(record) {
			const key = this.$route.query.key;
			const formData = this.createForm(record);
			axios
				.post(
					"/patient/" +
						this.monitoredSymptom.patient_id +
						"/record/" +
						record.id +
						"/edit?key=" +
						key,
					formData
				)
				.then(response => {
					console.log(response.data);
					if (response.data.result == "ok")
						this.$emit(
							"edit-record",
							this.monitoredSymptom,
							response.data.record
						);
					this.showEditRecord = false;
				})
				.catch(error => {
					console.log(error);
					this.$refs.editRecord.setError();
				});
		},
		openEditRecord(record) {
			this.recordToEdit = {
				id: record.id,
				date: record.date,
				time: record.time,
				intensity: record.intensity + 1
			};
			this.showEditRecord = true;
		}
	},
	watch: {
		showShareMonitoring(value) {
			if (value) {
				axios
					.get("/monitored_symptom/" + this.monitoredSymptom.id + "/shared_users")
					.then(response => {
						console.log(response.data);
						this.professionals = response.data.professionals;
					})
					.catch(error => console.log(error));
			} else {
				this.sharedProfessionalsChanged = false;
			}
		}
	},
	mounted() {
		this.monitoredSymptom.records.sort((a, b) => {
			const dateA = new Date(a.date + "T" + a.time);
			const dateB = new Date(b.date + "T" + b.time);
			return dateA - dateB;
		});
	}
};
</script>

<style scoped>
</style>